import { Autocomplete, TextField } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { useSurveyContext } from '../../Context/SurveyCustomHooks/useSurveyContext';
import { languageContext } from '../../../../../context/languageContext';
import { useIntl } from 'react-intl';

export const SelectCheckQuestion = () => {
    const intl = useIntl()
    const language = useContext(languageContext);
    const {
        activeStep,
        surveyQuestions,
        setEnableScrollMove,
        updateAnswers,
        answers,
        setAnswers,
        getLanguageOptions
    } = useSurveyContext();
    const question = surveyQuestions[activeStep];
    const [selectedOptions, setSelectedOptions] = React.useState([]);
    const [selectedValues, setSelectedValues] = useState([]);
    const options = getLanguageOptions(question, language.locale, "select");

    useEffect(() => {
        //* Quita las respuestas cuando se cambia el idioma
        //the options are changed, so we need to clean the answers
        //check if the selectedOptions are in options
        if (options?.length === 0 || selectedOptions?.length === 0 || answers?.length === 0) return;
        const selectedOptionsInQuestion = selectedOptions.filter(option => options.includes(option));
        if (selectedOptionsInQuestion.length === 0) {
            setAnswers(answers.filter(answer => answer.survey_item_id !== question.itemId));
            setSelectedValues([]);
        }
        //eslint-disable-next-line
    }, [selectedOptions, intl])


    useEffect(() => {
        // Initialize the selected values based on answers
        const initialValues = answers
            .filter(answer => answer.survey_item_id === question.itemId)
            .map(answer => answer.answer_value);
        setSelectedValues(initialValues);
        setSelectedOptions(initialValues);
        //eslint-disable-next-line
    }, []);

    /**
     * Handles change events for multiple-choice checkboxes.
     * Updates the selected values state and processes the answers accordingly.
     * 
     * @param {React.ChangeEvent} event - The change event triggered by the checkbox
     * @param {Array} value - Array containing all currently selected options
     * 
     * @description
     * This function:
     * 1. Updates the selectedValues state with the new selection array
     * 2. Identifies which option was added or removed from the previous selection
     * 3. Updates selectedOptions state with the new selection array
     * 4. If an option was added, updates answers with the new selection
     * 5. If all options were removed, filters out this question from answers
     * 6. If an option was removed, filters out that specific answer
     */
    const handleCheckChange = (event, value) => {
        setSelectedValues(value);
        //Value es un array con las opciones seleccionadas
        // Encuentra el último valor añadido o eliminado
        const added = value.find(option => !selectedOptions.includes(option));
        const removed = selectedOptions.find(option => !value.includes(option));
        setSelectedOptions(value);
        if (added) {
            return updateAnswers(question.itemId, added, "multiple");
        }
        if (value.length === 0) {
            return setAnswers(answers.filter(answer => answer.survey_item_id !== question.itemId));
        }
        if (removed) {
            return setAnswers(answers.filter(answer => answer.answer_value !== removed));
        }
    };

    return (
        <Autocomplete
            className=''
            multiple
            limitTags={4}
            //*Si hay opciones nulas, se muestran las opciones en español
            options={options}
            id={`selectcheck${(activeStep)}`}
            filterSelectedOptions
            onChange={handleCheckChange}
            value={selectedValues}
            // defaultValue={answers.filter(answer => answer.survey_item_id === question.itemId).map(answer => answer.answer_value)}
            onOpen={() => setEnableScrollMove(false)} // Se activa cuando el autocomplete se abre
            onClose={() => setEnableScrollMove(true)} // Se activa cuando el autocomplete se cierra
            renderOption={(props, option, { selected }) => {
                return (
                    <li {...props} className='RegularMadeTommy' key={props['data-option-index'] + language.locale}>
                        <input type="checkbox" style={{ margin: "10px 10px" }} checked={selected} readOnly />
                        {option ? option : question.options[props['data-option-index']]}
                    </li>
                )
            }}
            ChipProps={{ className: 'RegularMadeTommy mx-1' }}
            // renderTags={(tagValue, getTagProps) =>
            //     tagValue.map((option, index) => {
            //         const { key, ...tagProps } = getTagProps({ index });
            //         return (
            //             <Chip
            //                 key={key}
            //                 className='MuiChip-label'
            //                 label={option ? option : question.options[tagProps['data-option-index']]}
            //                 {...tagProps}
            //             />
            //         );
            //     })
            // }
            // isOptionEqualToValue={(option, value,) => {
            //     console.log(option, value)
            //     return option === value || option === "the first option is this";
            // }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label=""
                    sx={{
                        backgroundColor: 'white',
                        borderRadius: '10px',
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                border: 'none', // Elimina el borde del campo
                            }
                        },
                    }}
                    placeholder={intl.formatMessage({ id: "survey.error.selectMultiOption" })}
                    className='MediumMadeTommy'
                />
            )}
        />
    )
}
